import { MenuItem } from '../models/menu.model';
import { getCapabilities } from 'src/app/core/models/capabilities.model';
import { TranslateService } from '@ngx-translate/core';

/**
 * Obtener elementos del menú
 * @param translateService Servicio de traducción
 * @returns Elementos del menú
 */
function getMenuItems(translateService: TranslateService): MenuItem[] {
  return [
    {
      key: 'options',
      label: 'layout.sidebar.operations.title',
      isTitle: true,
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'LEASING')
          ?.key ?? '',
        getCapabilities(translateService).find((cap) => cap.key === 'QUERY')
          ?.key ?? '',
      ],
    },
    {
      key: 'dashboard',
      label: 'layout.sidebar.operations.items.dashboard',
      isTitle: false,
      icon: 'mdi mdi-view-dashboard-outline',
      url: '/dashboard',
      capabilities: [],
    },
    {
      key: 'upload',
      label: 'layout.sidebar.operations.items.upload',
      isTitle: false,
      icon: 'mdi mdi-cloud-upload-outline',
      url: '/upload',
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'LEASING')
          ?.key ?? '',
      ],
    },
    {
      key: 'lease',
      label: 'layout.sidebar.operations.items.lease',
      isTitle: false,
      icon: 'mdi mdi-file-plus-outline',
      url: '/lease',
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'LEASING')
          ?.key ?? '',
      ],
    },
    {
      key: 'listing',
      label: 'layout.sidebar.operations.items.listing',
      isTitle: false,
      icon: 'mdi mdi-file-document-multiple-outline',
      url: '/listing',
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'LEASING')
          ?.key ?? '',
      ],
    },
    {
      key: 'search',
      label: 'layout.sidebar.operations.items.search',
      isTitle: false,
      icon: 'mdi mdi-magnify',
      url: '/search',
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'QUERY')
          ?.key ?? '',
      ],
    },
    {
      key: 'settings',
      label: 'layout.sidebar.settings.title',
      isTitle: true,
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'CONFIG')
          ?.key ?? '',
      ],
    },
    {
      key: 'users',
      label: 'layout.sidebar.settings.items.users',
      isTitle: false,
      icon: 'mdi mdi-account-group-outline',
      url: '/users',
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'CONFIG')
          ?.key ?? '',
      ],
    },
    {
      key: 'certificates',
      label: 'layout.sidebar.settings.items.certificates',
      isTitle: false,
      icon: 'mdi mdi-certificate',
      url: '/certificates',
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'CONFIG')
          ?.key ?? '',
      ],
    },
    {
      key: 'log',
      label: 'layout.sidebar.settings.items.log',
      isTitle: false,
      icon: 'mdi mdi-text',
      url: '/log',
      capabilities: [
        getCapabilities(translateService).find((cap) => cap.key === 'CONFIG')
          ?.key ?? '',
      ],
    },
    {
      key: 'components',
      label: 'layout.sidebar.help.title',
      isTitle: true,
      capabilities: [],
    },
  ];
}

export { getMenuItems };
